import { useEffect, useState } from 'react';
import {
  Create,
  PasswordInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  email,
} from 'react-admin';

import { apiFetch } from '../../api/client';

interface RoleOption {
  id: string;
  name: string;
}

export function UserCreate() {
  const [roles, setRoles] = useState<RoleOption[]>([]);

  useEffect(() => {
    apiFetch<{ data: Array<{ id: number; name: string }> }>('/admin/roles')
      .then((res) =>
        setRoles(
          res.data
            .filter((r) => r.name !== 'business_owner')
            .map((r) => ({ id: r.name, name: r.name.replace(/_/g, ' ') })),
        ),
      )
      .catch(() => setRoles([]));
  }, []);

  return (
    <Create redirect="list">
      <SimpleForm>
        <TextInput source="full_name" label="Full name" validate={[required()]} fullWidth />
        <TextInput source="email" validate={[required(), email()]} fullWidth />
        <PasswordInput source="password" validate={[required()]} fullWidth />
        <SelectInput
          source="role"
          label="Role"
          choices={roles}
          validate={[required()]}
          fullWidth
        />
      </SimpleForm>
    </Create>
  );
}
